export function makeSenderCity(defaultFields) {
    if (!defaultFields.sender_city_uuid) {
        return null;
    }

    let city = {
        uuid: defaultFields.sender_city_uuid,
        name: defaultFields.sender_city_name ?? '',
        district: defaultFields.sender_city_district ?? null,
        region: defaultFields.sender_city_region ?? null
    };

    return city;
}

export function makeSenderWarehouse(defaultFields) {
    if (!defaultFields.sender_city_uuid || !defaultFields.sender_address_uuid) {
        return null;
    }

    let warehouse = {
        uuid: defaultFields.sender_address_uuid,
        name: defaultFields.sender_address_name ?? ''
    };

    return warehouse;
}

export function makeDimensionsForm(defaultFields) {
    let dimensions = defaultFields.dimensions ?? {};

    let form = {
        seats_amount: dimensions.seats_amount ?? '',
        weight: dimensions.weight ?? '',
        length: dimensions.length ?? '',
        width: dimensions.width ?? '',
        height: dimensions.height ?? ''
    };

    return form;
}

export function buildDimensions(form) {
    let dimensions = {};

    for (let [field, value] of Object.entries(form)) {
        dimensions[field] = value === '' ? null : Number(value);
    }

    return dimensions;
}

export function buildSenderAddressFields(city, warehouse) {
    let fields = {
        sender_city_uuid: city?.uuid ?? null,
        sender_city_name: city?.name ?? null,
        sender_city_district: city?.district ?? null,
        sender_city_region: city?.region ?? null,
        sender_address_uuid: warehouse?.uuid ?? null,
        sender_address_name: warehouse?.name ?? null
    };

    return fields;
}
